export const STRIPE_BRAND = '#635bff';
